import { MessageOutlined, ReloadOutlined } from "@ant-design/icons";
import { Avatar, Button, Card, Empty, List, Tooltip } from "antd-v4";

import moment from 'moment';
import 'moment/locale/fr';
import { useNavigate } from "react-router-dom";

import Loader from "../../../view/components/loader";
import { jobTypeAsString } from "@leedpulse-monorepo/enums";

moment.updateLocale("fr", {
    relativeTime: {
        future: "dans %s",
        past: "il y a %s",
        s: "quelques secondes",
        ss: "%d secondes",
        m: "une minute",
        mm: "%d minutes",
        h: "une heure",
        hh: "%d heures",
        d: "un jour",
        dd: "%d jours",
        M: "un mois",
        MM: "%d mois",
        y: "un an",
        yy: "%d ans",
    },
});

export default function MainCard(props) {

    const navigate = useNavigate();

    const items = props.data.map((item) => {
        return {
            id: item.id,
            firstname: item.contact.contact.firstname,
            lastname: item.contact.contact.lastname,
            timestamp: item.timestamp,
            type: item.type,
            contact: item.contact
        }
    }).slice(0, 3);

    return (
        <Card style={{ height: 435 }} className="hp-border-radius-lg">

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }} className="hp-d-flex">
                {props.icon && (
                    <div
                        className="hp-d-flex-full-center hp-dashboard-feature-card-icon hp-border-radius-lg hp-bg-black-20 hp-bg-dark-85"
                        style={{ width: 48, height: 48 }}
                    >
                        {props.icon}
                    </div>
                )}

                <span
                    className="hp-text-color-dark-0 hp-d-block h1"
                    style={{
                        color: props.numberColor || "#000",
                    }}
                >
                    {props.number}
                </span>
            </div>

            {props.title && (
                <span style={{ marginTop: '1rem' }} className="h5 hp-mb-0 hp-d-block hp-text-color-black-bg hp-text-uppercase hp-text-color-dark-0 hp-font-weight-500 hp-mr-4">
                    {props.title}
                </span>
            )}

            {
                props.loading ? <Loader /> :
                  items.length === 0 ?
                    <Empty
                      description={
                        <span>
                          <i>Aucune action planifiée.</i><br />Il est peut-être temps d'importer des contacts ?
                        </span>
                      }
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      style={{ marginTop: '4rem' }}
                    />
                    :
                    <List
                        loading={props.loading}
                        dataSource={items}
                        renderItem={(item) => (
                            <List.Item key={item.id}>
                                <List.Item.Meta
                                  title={item.firstname + ' ' + item.lastname}
                                  description={jobTypeAsString(item.type)}
                                  avatar={<Avatar size='large'>{item.firstname.slice(0, 1) + item.lastname.slice(0, 1)}</Avatar>}
                                />
                                <div
                                    style={{
                                        marginRight: 20,
                                        color:
                                            // Lecture de l'horloge pendant le rendu : non deterministe, donc signale par
                                            // react/purity. C'est inherent ici — l'affichage depend de « maintenant »
                                            // (age d'un appel, marqueur de la timeline, fenetre de fraicheur). Le
                                            // correctif est un hook d'horloge partage (`useNow`) consomme par les 11
                                            // sites : cf. TECH_DEBT.md, « 11 lectures d'horloge en rendu ».
                                            // eslint-disable-next-line react/purity
                                            item.timestamp > Date.now() && (Math.abs(moment().diff(moment(item.timestamp), 'hours')) < 3)
                                                ? 'green'
                                                : 'orange'
                                    }}
                                >
                                    {moment(item.timestamp).fromNow()}
                                </div>
                                <Tooltip title='Accéder à la conversation'>
                                    <Button size="small" type="primary" icon={<MessageOutlined />} onClick={() => {
                                        return (
                                            navigate(`/conversations`, {
                                                state: { selectedContact: item.contact, isFromOtherPage: true },
                                            })
                                        )
                                    }} />
                                </Tooltip>
                            </List.Item>
                        )}
                    />
            }

            <div style={{ position: 'absolute', right: '1rem', bottom: '1rem' }}>
                <Button icon={<ReloadOutlined style={{ marginRight: 5 }} />} type="link" size="small" onClick={props.onRefresh}>Rafraîchir</Button>
            </div>
        </Card>
    );
}
